import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const InviteLinkDialog = ({ invite, onClose }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(invite.link);
      setCopied(true);
      toast.success("Link copied");
    } catch {
      toast.error("Couldn't copy automatically. Select the link and copy it.");
    }
  };
  return (
    <Dialog open={!!invite} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="invite-link-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{invite?.title || `Set-password link for ${invite?.name}`}</DialogTitle>
          <DialogDescription>{invite?.description || "Send this private link to the locksmith (text or email). It lets them set their password and expires in 7 days."}</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <Input readOnly value={invite?.link || ""} onFocus={(e) => e.target.select()} className="font-data text-xs" data-testid="invite-link-input" />
          <Button type="button" onClick={copy} className="bg-blue-700 hover:bg-blue-800" data-testid="invite-link-copy-button">
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          </Button>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="invite-link-close-button">Done</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
